module.exports = __webpack_public_path__ + "0a8b184529da79a507b9d20ca78941c2.MP3";